import { useState } from "react";
import { MessageCircle } from "lucide-react";
import BranchChooser from "./BranchChooser";

export default function WhatsAppFab() {
    const [open, setOpen] = useState(false);
    return (
        <>
            <button
                onClick={() => setOpen(true)}
                data-testid="whatsapp-fab"
                aria-label="Open WhatsApp booking"
                className="pulse-ring fixed bottom-20 right-6 z-50 w-14 h-14 lg:w-16 lg:h-16 rounded-full bg-[#25D366] text-white shadow-2xl flex items-center justify-center hover:bg-[#1ebf5a] transition-all hover:scale-105"
            >
                <MessageCircle size={26} strokeWidth={1.7} />
            </button>

            <BranchChooser
                open={open}
                onOpenChange={setOpen}
                title="Book via WhatsApp"
                description="Choose your preferred branch — we'll open a chat with our team."
                message="Hi, I would like to book a Thai massage at Aekkarag. Could you share availability?"
            />
        </>
    );
}
